import { useState, useEffect } from 'react';
import { setNewPassword } from '../../api/Auth';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { toast } from 'react-toastify';
import { PasswordStrengthMeter } from '../PasswordStrengthMeter/PasswordStrengthMeter';
import { checkPasswordStrength } from "../../utils/PasswordStrengthMeter";

const { REACT_APP_ClientKey, REACT_APP_VERSION } = process.env;

const ResetPassword = () => {
  const navigate = useNavigate();
  const clientKey = `${REACT_APP_ClientKey}`;

  //States
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordStrength, setPasswordStrength] = useState({ strength: 0, obj: { color: "", text: "" }} as any);
  const [confirmPasswordStrength, setConfirmPasswordStrength] = useState({ strength: 0, obj: { color: "", text: "" }} as any);
  const [captcha, setCaptcha] = useState(true);
  let [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    let email  = searchParams.get('email')
    setEmail(email?email:'')
  
  }, [searchParams]);

  //Functions
  //Handles the change in inputted password
  const handleInputChange = (event: any) => {
    event.preventDefault();
    const { target } = event;
    if (target.name === 'password') {
      setPassword(event.target.value);
      setPasswordStrength(checkPasswordStrength(event.target.value))
    }
    if (target.name === 'confirm-password') {
      setConfirmPassword(target.value);
      setConfirmPasswordStrength(checkPasswordStrength(event.target.value))
    }
  };

  //Handles the submit
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&-])[A-Za-z\d@$!%*#?&-]{8,}$/;

    let token=searchParams.get('token');
    let email=searchParams.get('email')
    let timeStamp = searchParams.get('dt')
    const resetDate = Number(timeStamp)
    let currentDate = new Date()

    if(currentDate.getTime() > resetDate) {
      toast.error('Sorry, this link has expired.');
    } else {
      if (!(regex.test(password))) {
        toast.error('Password must be at least 8 characters long with no blank spaces and contain a mix of at-least 1 letter, 1 number, and 1 symbol.');
      } else {
        if (password === confirmPassword) {
          setNewPassword(token,email,confirmPassword)
            .then((res) => {
              console.log(res);
              if (searchParams.get('type') === '1') {
                // window.location.replace(REACT_APP_ADMIN_PORTAL);
              } else {
                navigate('../signin');
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toast.error('Both passwords should be same');
        }
      }
    }
  };

  if (captcha) {
    return (
      <div>
        <div className='container'>
          <div className='row mt-5'>
            <div className='col-3'>
              <img src='/assets/Logos/AppIcon.png' />
            </div>
            <div className='col'></div>
          </div>
          <div className='row mt-5'>
            <div className='col-4'></div>
            <div className='col'>
              <h1>Reset Password</h1>
              <form>
                <div className='mb-4'>
                  <label className='form-label'>Email address</label>
                  <input
                    type='email'
                    className='form-control'
                    name='email'
                    value={email}
                    disabled
                  />
                </div>
                <label className='form-label'>New Password</label>
                <PasswordStrengthMeter name={'password'} handleChange={handleInputChange} passwordStrength={passwordStrength}/>
                <label className='form-label'>Confirm Password</label>
                <PasswordStrengthMeter name={'confirm-password'} handleChange={handleInputChange} passwordStrength={confirmPasswordStrength}/>
                <button
                  type='submit'
                  className='btn btn-primary'
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </form>
            </div>
            <div className='col-4'></div>
          </div>
        </div>
        <div style={{ position: 'fixed', bottom: '0', right: '1%' }}>
          <p>v{REACT_APP_VERSION}</p>
        </div>
      </div>
    );
  } else {
    return (
      <div style={{ position: 'absolute', left: '40%', top: '40%' }}>
        <div>
          <ReCAPTCHA
            sitekey={clientKey}
            onChange={() => {
              setCaptcha(true);
            }}
          />
        </div>
      </div>
    );
  }
};

export default ResetPassword;